import { render, staticRenderFns } from "./Kraemmerne.vue?vue&type=template&id=10988f5f&"
import script from "./Kraemmerne.vue?vue&type=script&lang=js&"
export * from "./Kraemmerne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports